import { render, staticRenderFns } from "./float-menu.component.vue?vue&type=template&id=4f9da963&scoped=true&lang=pug"
import script from "./float-menu.component.vue?vue&type=script&lang=ts"
export * from "./float-menu.component.vue?vue&type=script&lang=ts"
import style0 from "./float-menu.component.vue?vue&type=style&index=0&id=4f9da963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9da963",
  null
  
)

export default component.exports